export default "__VITE_ASSET__C9tlzYxj__"